<template>
  <ElConfigProvider :size="state.size" :z-index="state.zIndex">
    <div v-if="isEditorRoute" class="w-full h-full flex flex-col">
      <RouterView />
    </div>

    <div v-else class="app-shell">
      <AppNavigation />
      <main class="main-content-area">
        <RouterView />
      </main>
      <AppFooter />
    </div>
  </ElConfigProvider>
</template>

<script setup lang="ts">
import { reactive, computed } from 'vue';
import { useRoute } from 'vue-router';
import AppNavigation from '@/components/layout/AppNavigation.vue';
import AppFooter from '@/components/layout/AppFooter.vue';

const state = reactive({
  zIndex: 3000,
  size: 'small'
});

// Get the current route information
const route = useRoute();

// Create a computed property to check if we are on an editor page
const isEditorRoute = computed(() => {
  return route.path === '/editor' || route.path === '/mobileeditor';
});
</script>

<style>
/* This CSS provides the robust layout for non-editor pages */
html, body, #vite-app {
  height: 100%;
  margin: 0;
  /* overflow: hidden; -- We only want to hide overflow on the app shell */
}

.app-shell {
  display: flex;
  flex-direction: column;
  min-height: 100%; /* Use min-height to ensure it covers the screen */
}

.main-content-area {
  flex-grow: 1; /* This makes the main area take up all available space */
  overflow-y: auto;
  scroll-behavior: smooth;
}
</style>